<template>
  
  <v-app>
    <link rel="manifest" href="homescreen_manifest.json"/>
    <v-navigation-drawer v-model="sideNav" temporary> 
    <v-list>
       <v-list-tile
          v-for="item in menuItems"
          :key="item.title"
          router
          :to="item.link">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>
          <v-list-tile
          v-if="userIsAuthenticated"
          @click="onLogout">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Logout</v-list-tile-content>
        </v-list-tile>
    </v-list>
    </v-navigation-drawer> 
    <v-toolbar dark class="primary" app >
      <v-toolbar-side-icon @click.stop="sideNav = !sideNav"
      class="hidden-sm-and-up "
      >
      </v-toolbar-side-icon>
      <v-toolbar-title>
       <router-link to="/" tag="span" style="cursor:pointer" >Soloya Offertes</router-link>
      </v-toolbar-title>
      
      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-xs-only">
        <v-btn
            flat
            v-for="item in menuItems"
            :key="item.title"
            :to="item.link">
            <v-icon left dark>{{ item.icon }}</v-icon>
            {{ item.title }}
        </v-btn>
         <v-btn
          v-if="userIsAuthenticated"
          flat
          @click="onLogout">
          <v-icon left dark>exit_to_app</v-icon>
          Logout

        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
   <main>
      <router-view></router-view>
    </main>
  </v-app>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
      sideNav: false
    }
  },
  computed:{
    menuItems(){
      let menuItems = [
           { icon: 'lock_open', title: 'Login', link: '/login' }
        ]
     if(this.userIsAuthenticated) {
         menuItems = [
          { icon: 'note_add', title: 'Nieuw',  link: '/offerte/new' },
          { icon: 'receipt',  title: 'Lijst',  link: '/offerte' }
        ]
     }
     return menuItems;
    },
    userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
  },
  methods : {
    onLogout(){
      this.$store.dispatch('logout')
    }
  }
}
</script>